import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlStatusMessage, StatusMessage} from '../../graphql/common.datatypes';

interface SendVerifyEmailVars {
    id: number
}

interface SendVerfyEmailData {
    sendVerifyEmail: StatusMessage
}

export const SEND_VERIFY_EMAIL_MUTATION = gql`
    mutation sendVerifyEmail($id: Int!) {
        sendVerifyEmail(id: $id) {
            ${gqlStatusMessage}
        }
    }
`;

export const sendVerifyEmail = () => useMutation<SendVerfyEmailData, SendVerifyEmailVars>(
    SEND_VERIFY_EMAIL_MUTATION, {}
);

export default sendVerifyEmail;
